import { render } from "./Import_Departments.vue?vue&type=template&id=3471ab8e"
import script from "./Import_Departments.vue?vue&type=script&lang=js"
export * from "./Import_Departments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__